<template>
<div class="addVenue">
 <!-- Main Body Content area -->
    <div class="o-main-content-area o-main-content-area--padBotoomNone">
        <!-- Heading Section -->
        <div class="row c-responsive-fixwidth">
            <div class="col-md-12">
                <h1 class="h1 text-center">Add Venue</h1>
            </div>
        </div>
        <!-- /Heading Section -->
    </div>
    <!-- /Main Body Content area -->

    <div class="o-ndividualArea c-responsive-fixwidth">
        <div class="col-md-6 col-md-offset-3">
            <div class="c-common-box-shadow o-super-client-area c-radius3 u-bg-white">
                <div class="row">
                    <div class="col-sm-12 o-modal-field-area">
                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                            <label class="common-label-text common-label-text--modalwidth">Name:</label>
                        </div>
                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                <el-autocomplete
                                    class="inline-input"
                                    v-model="address.name"
                                    :fetch-suggestions="querySearch"
                                    placeholder="Venue Name"
                                    v-validate="{ required: true }" 
                                    name="name"
                                    :trigger-on-focus="false"
                                    @select="handleSelect"
                                ></el-autocomplete>
                                    
                                    <!-- <input type="text" class="form-control" placeholder="Name" v-model="address.name" v-validate="{ required: true }" name="name"> -->
                                <span v-show="errors.has('name') && this.validation_err!=0" class="err-msg">{{ errors.first('name') }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 o-modal-field-area">
                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                            <label class="common-label-text common-label-text--modalwidth">Street:</label>
                        </div>
                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                <input type="text" class="form-control" placeholder="Street Name" v-model="address.address" v-validate="{ required: true }" name="address">
                                <span v-show="errors.has('address') && this.validation_err!=0" class="err-msg">{{ errors.first('address') }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 o-modal-field-area">
                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                            <label class="common-label-text common-label-text--modalwidth">City/Town:</label>
                        </div>
                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                <input type="text" class="form-control" placeholder="City/Town Name" v-model="address.municipality" v-validate="{ required: true }" name="municipality">
                                <span v-show="errors.has('municipality') && this.validation_err!=0" class="err-msg">{{ errors.first('municipality') }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 o-modal-field-area">
                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                            <label class="common-label-text common-label-text--modalwidth">State/Province:</label>
                        </div>
                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                <input type="text" class="form-control" placeholder="State/Province Name" v-model="address.state_province" v-validate="{ required: true }" name="state_province">
                                <span v-show="errors.has('state_province') && this.validation_err!=0" class="err-msg">{{ errors.first('state_province') }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 o-modal-field-area">
                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                            <label class="common-label-text common-label-text--modalwidth">Postal Code:</label>
                        </div>
                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                <input type="text" class="form-control" placeholder="Postal Code" v-model="address.postcode" v-validate="{ required: true }" name="postcode">
                                <span v-show="errors.has('postcode') && this.validation_err!=0" class="err-msg">{{ errors.first('postcode') }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 o-modal-field-area">
                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                            <label class="common-label-text common-label-text--modalwidth">Country:</label>
                        </div>
                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                <input type="text" class="form-control" placeholder="Country Name" v-model="address.country" v-validate="{ required: true }" name="country">
                                <span v-show="errors.has('country') && this.validation_err!=0" class="err-msg">{{ errors.first('country') }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="closeAddVenueAddress()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="addNewVenue()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-save"></i> Save</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
    <modal name="calender-details" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
        <div tabindex="-1" role="dialog">
                <div role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header text-center">
                            <!-- <button @click="closeMap()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> -->
                            <h1 class="modal-title">Verify the venue in Google Map</h1> 
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body o-modal-body--calender">
                            <div class="row">
                                <div class="col-sm-12 o-no-padding o-calender-container">

                                    <div class="col-md-7 o-calender-area">
                                        
                                        <div class="custom-row u-common-box-shadow c-radius3">
                                            <div class="o-calls-table">
                                                <div class="o-common-head">
                                                    <h5 class="c-common-heading"><i class="fa fa-map-marker" aria-hidden="true"></i> Venue: {{full_address_map}}</h5>
                                                </div>
                                                <div class="o-map-conatiner">
                                                    <iframe 
                                                        width="100%"
                                                        height="100%"
                                                        frameborder="0" style="border:0"
                                                        :src="getMapUrl()" allowfullscreen>
                                                    </iframe>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <button @click="closeMap()" type="button" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue" data-dismiss="modal" aria-label="Close"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</button>
                                </li>
                                <li>
                                    <button @click="saveVenue()" type="button" class="btn c-solid-btn c-solid-btn--large c-solid-btn--green" ><i class="fa fa-check" aria-hidden="true"></i> Verify and Save</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- /.modal-content -->
                </div>
                <!-- /.modal-dialog -->
        </div>
    </modal>
</div>

</template>
<script>
    import { mapGetters, mapActions} from 'vuex';
    import service from '../../services.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    import {loaded} from 'vue2-google-maps'

    export default {
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID'
            })
        },
        data() {
            return {
                address: {
                    "name": "",
                    "address": "",
                    "municipality": "",
                    "state_province": "",
                    "country": "",
                    "postcode": "",
                    "client_id": "",
                    "venueID": "",
                    'status': 0,
                },
                validation_err: 0,
				venueVerify:0,
                allVenue:[],
                full_address_map:'',
            }
        },
        created() {
            this.addClientlist.url = document.location.href.split('#')[0] + "#/reset-password";
        },
        methods: {
            closeMap() {
                this.$modal.hide("calender-details");
            },
            getMapUrl(){
				return dateTimeConvert.getMapUrl(this.full_address_map);
			},
            getAllVenue(){
                this.fetchFlag=false;
                service.get('getAllVenue', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).then((res) => {
                    var temp = res.data.result;
                    for(var key in temp){

                        this.allVenue.push({'value':temp[key].name, 'id':temp[key].id});
                    }
                    //console.log(this.allVenue);
                    this.fetchFlag=true;
                }).catch((err) => {
                    console.log(err);
                    this.fetchFlag=true;
                });
            },
            querySearch(queryString, cb) {
                var links = this.allVenue;
                var results = queryString ? links.filter(this.createFilter(queryString)) : links;
                // call callback function to return suggestions
                cb(results);
            },
            createFilter(queryString) {
                return (link) => {
                  return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {
                // console.log(item);
            },
			addNewVenue() {
                let self=this;
                this.$validator.validateAll().then( async (result) => {
                    if (result) {
                        this.validation_err = 0;
                        // var geocoder = new google.maps.Geocoder();
                        // geocoder.geocode({
                        //     'address': this.address.name+', '+this.address.address+', '+this.address.municipality+', '+this.address.state_province+', '+this.address.postcode+', '+self.address.country
                        // }, (results, status)=> {
                        //     if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
                        //         self.address['status']=1;
                        //         console.log(self.address);
                        //         self.saveVenue();
                        //     } else {
                        //         self.address['status']=0;
                        //         console.log(self.address);
                        //         self.saveVenue();
                        //     }
                        // })
                        // self.saveVenue();
                        this.full_address_map= this.address.name+', '+this.address.address+', '+this.address.municipality+', '+this.address.state_province+', '+this.address.postcode+', '+self.address.country;
                        this.$modal.show("calender-details");
                        
                    } else {
                        this.validation_err = 1;

                    }
                });
            },
            saveVenue(){
                this.address['status']=1;
                this.address.client_id = this.userClientID;
                service.post('venue', this.address, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).then((res) => {
                    //this.venues.push(res.data.result);
                    // this.modal.hide("venue-add-address");
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Venue updated Successfully.',
                        type: 'success'
                    });
                    setTimeout(() => {
                        this.closeAddVenueAddress();
                    }, 1000);
                    
                }).catch((err) => {
                    console.log("err");
                });  
            },
            closeAddVenueAddress(){
            	this.$router.push({
                    'path': '/venue'
                });
            }
        },
        created(){
        	this.getAllVenue();
        }
    }

</script>
<style scoped>
.o-map-conatiner{
    height: 285px;
}
</style>



// WEBPACK FOOTER //
// src/components/venue/addVenue.vue